import React, { Component, useState, Fragment, useEffect } from "react";
import { injectIntl } from "react-intl";
import API from "../../api/index";
import ReactAutosuggest from "Components/ReactAutosuggest";
import StockIndicator, { StockBox, StockSuggestion } from 'Components/StockIndicator';
var classNames = require("classnames");
import Switch from "rc-switch";
import "rc-switch/assets/index.css";
import { Row, Card, CardBody, CardTitle, Form, FormGroup, Button, Label, Input, Modal, ModalHeader, ModalBody, ModalFooter, Table, Collapse, CustomInput, timeoutsShape } from "reactstrap";

import NumericInput from "react-numeric-input";
import NumberFormat from "react-number-format";
import Rating from "Components/Rating";

import { logoutUser } from "Redux/actions";
import { connect } from "react-redux";

import { Colxx } from "Components/CustomBootstrap";
import { NotificationManager } from "Components/ReactNotifications";
import CustomerMobileLookup, { parentCustomerMobileObject } from "Components/CustomerMobileLookup";
// const ProductCategories = [...new Set(ProductsData.map(item => item.category))];

class NewOrder extends Component {
	constructor(props) {
		super(props);
		this.handleChange = this.handleChange.bind(this);
		this.handleChangeType = this.handleChangeType.bind(this);

		this.state = {
			DeliveryInPerson: false,
			orderUrl: "",
			orderId: "",
			modalURL: false,
			backdrop: true,

			factorItems: {
				notePublic: false,
				notePirvate: false,
				rating: false,
			},
			ratingOperator: 0,
			orderType: false,
			customerMobile: parentCustomerMobileObject,
			toggleMotefareghe: false,
			selectedOptions: [],
			selectedOptionsType: [],
			backdrop: true,
			discountAmount: 0,
			discountPercent: 0,
			additionalFee: 0,
			discountType: "FIXED",
			couponCode: "",
			couponID: -1,
			coupon: {
				type: "FIXED",
				amount: 20000,
				minSpend: 200000,
			},
			useCoupon: false,
			lookingUpCoupon: false,

			notePublic: "",
			notePrivate: "",
			displayMode: "imagelist",
			productsData: [],
			productsDataTree: [],
			productCategories: [],
			productsDataWithStock: [],
			variableProduct: {
				id: "V-0",
				idCounter: 0,
				name: "",
				price: 0,
				count: 0,
				type: "VARIABLE",
			},
			variableProducts: [],
			isLoading: true,
		};
		this.customerMobileLookupComponent = React.createRef();
		this.handleCustomerMobileChange = this.handleCustomerMobileChange.bind(this);

		this.toggleAccordion = this.toggleAccordion.bind(this);
		this.toggleDisplayOptions = this.toggleDisplayOptions.bind(this);
		this.toggleSplit = this.toggleSplit.bind(this);
		this.addVariableProduct = this.addVariableProduct.bind(this);
		this.validateAddVariableProduct = this.validateAddVariableProduct.bind(this);
		this.deleteFromFactor = this.deleteFromFactor.bind(this);
		this.changeCountFromFactor = this.changeCountFromFactor.bind(this);
		this.validatePlaceOrder = this.validatePlaceOrder.bind(this);
		this.loadData = this.loadData.bind(this);
		this.handleCountUpdate = this.handleCountUpdate.bind(this);
		this.getItemCount = this.getItemCount.bind(this);
		this.getItemPrice = this.getItemPrice.bind(this);
		this.getItemStock = this.getItemStock.bind(this);
		this.getItemReserved = this.getItemReserved.bind(this);
		this.flatTreeData = this.flatTreeData.bind(this);
		this.flatTreeDataLoop = this.flatTreeDataLoop.bind(this);
		this.toggleMotefareghe = this.toggleMotefareghe.bind(this);
		this.validateOrderType = this.validateOrderType.bind(this);
		this.updateSize = this.updateSize.bind(this);
		this.componentDidMount = this.componentDidMount.bind(this);
		this.handlediscountPercent = this.handlediscountPercent.bind(this);
		this.getTotalPayAblePrice = this.getTotalPayAblePrice.bind(this);
		this.placeOrder = this.placeOrder.bind(this);
		this.validateRating = this.validateRating.bind(this);
		this.getCountedProducts = this.getCountedProducts.bind(this);
		this.couponLookup = this.couponLookup.bind(this);
		this.totalDiscount = this.totalDiscount.bind(this);
		this.formatNumber = this.formatNumber.bind(this);
		this.loadData();
	}
	handleCustomerMobileChange(customerMobileObject) {
		this.setState({ customerMobile: customerMobileObject });
	}
	handleFocus = (event) => event.target.select();
	formatNumber(number) {
		return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
	}
	totalDiscount() {
		if (this.state.useCoupon && this.state.couponID != -1) {
			const factorTotal = this.getFactorTotalPrice();
			const couponAmount = this.state.coupon.amount;
			const couponMinSpend = this.state.coupon.minSpend;
			if (this.state.coupon.type == "FIXED") {
				if (couponMinSpend > factorTotal) {
					return {
						amount: 0,
						info: "حداقل سفارش:  " + this.formatNumber(couponMinSpend) + " تومان",
						type: "COUPON",
						infoColor: "error",
					};
				} else {
					return {
						amount: couponAmount,
						info: "کوپن " + this.formatNumber(couponAmount) + "  تومان",
						type: "COUPON",
						infoColor: "success",
					};
				}
			} else if (this.state.coupon.type == "PERCENT") {
				if (couponMinSpend > factorTotal) {
					return {
						amount: 0,
						info: "حداقل سفارش: " + this.formatNumber(couponMinSpend) + " تومان",
						type: "COUPON",
						infoColor: "error",
					};
				} else {
					return {
						amount: Math.floor((couponAmount * factorTotal) / 100),
						info: "کوپن " + couponAmount + " %",
						type: "COUPON",
						infoColor: "success",
					};
				}
			}
		} else {
			return {
				amount: this.state.discountAmount,
				info: "",
				type: "INPUT",
			};
		}
	}
	couponLookup() {
		this.setState({ lookingUpCoupon: true });
		API.post("crm/coupon/lookup", { couponCode: this.state.couponCode })
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;
				if (data.COUPON !== undefined) {
					this.setState({ coupon: data.COUPON, lookingUpCoupon: false, couponID: data.COUPON.couponID });
				} else {
					this.setState({
						coupon: {},
						lookingUpCoupon: false,
						couponID: -1,
					});
				}

				if (data.ERRORS !== undefined) {
					for (var i = 0; i < data.ERRORS.length; i++) {
						setTimeout(
							function (err) {
								NotificationManager.error(err, "بررسی کوپن", 8000, null, null, "filled");
							},
							(i + 1) * 700,
							data.ERRORS[i]
						);
					}
				}
			})
			.catch((error) => {
				this.setState({
					coupon: {},
					lookingUpCoupon: false,
					couponID: -1,
				});
				NotificationManager.error("مشکل در بررسی کوپن", "بررسی کوپن", 8000, null, null, "filled");
			});
	}
	componentDidMount() {
		window.addEventListener("resize", this.updateSize);
		this.updateSize();
	}
	validateRating() {
		return true;
		// return this.state.ratingOperator > 0;
	}
	updateSize() {
		if (!this.state.isLoading && document.querySelector(".auto-win-height") !== null) {
			window.autoWinWidth = document.querySelector(".auto-win-height").offsetWidth;
			document.querySelector(".auto-win-height").style.overflow = "hidden";
			document.querySelector(".auto-win-height").style.width = document.querySelector("#side-card").offsetWidth + "px";
			document.querySelector(".auto-win-height").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 80 + "px";
			document.querySelector(".auto-win-height").style.position = "fixed";
			document.querySelector(".auto-win-height").style.top = document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight + 40 + "px";
			document.querySelector(".auto-win-height-scroll").style.height = window.innerHeight - document.querySelector("nav.navbar.fixed-top.mobile-hide").offsetHeight - 200 + "px";
			document.querySelector(".auto-win-height-scroll").style.overflow = "scroll";
		}
	}

	loadData(key) {
		API.order.new
			.productsTree()
			.then((data) => {
				data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

				this.setState({
					productsDataTree: data,
				});
				API.order.new
					.productsData()
					.then((data) => {
						data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

						const productsDataWithStock = data.map((product) => ({
							...product,
							name: product.stockReserved > 0 ? `${product.name} [ ${product.stockLevel >= 0 ? product.stockLevel : 0} : ~${product.stockReserved} ]` : `${product.name} [ ${product.stockLevel >= 0 ? product.stockLevel : 0} ]`,
						}));

						this.setState({
							productsData: data,
							productsDataWithStock,
							isLoading: false,
						});
						this.updateSize();
					})
					.catch((error) => {});
			})
			.catch((error) => {});
	}

	placeOrder() {
		if (this.validatePlaceOrder()) {
			var orderData = {
				customerMobile: this.state.customerMobile.mobile,
				orderType: this.state.orderType,
				ratingOperator: this.state.ratingOperator,
				notePublic: this.state.notePublic,
				notePrivate: this.state.notePirvate,
				additionalFee: this.state.additionalFee,
				discountType: this.state.couponID == -1 ? this.state.discountType : this.state.coupon.type,
				discountPercent: this.state.couponID == -1 ? this.state.discountPercent : this.state.coupon.type == "PERCENT" ? this.state.coupon.amount : this.state.discountPercent,
				discountAmount: this.state.couponID == -1 ? this.state.discountAmount : this.totalDiscount().amount,
				DeliveryInPerson: this.state.DeliveryInPerson ? "yes" : "no",
				payable: this.getTotalPayAblePrice(),
				products: this.getCountedProducts(),
				couponID: this.state.couponID,
			};
			this.setState({ isLoading: true });
			API.order.new
				.place(orderData)
				.then((data) => {
					data.RELOGIN ? this.props.logoutUser(this.props.history) : 0;

					if (data.ERRORS !== undefined) {
						for (var i = 0; i < data.ERRORS.length; i++) {
							setTimeout(
								function (err) {
									NotificationManager.error(err, "خطا در ثبت سفارش", 8000, null, null, "filled");
								},
								(i + 1) * 700,
								data.ERRORS[i]
							);
							this.setState({
								isLoading: false,
								modalURL: false,
							});
						}
					} else {
						this.setState({
							orderUrl: "https://cust.akschap.com/app/order/take/" + data.order.CustomerDataAccessCode,
							orderID: data.order.OrderId,
							isLoading: false,
							modalURL: true,
						});
					}
					this.updateSize();
				})
				.catch((error) => {});
		}
	}
	toggleMotefareghe() {
		this.setState({ toggleMotefareghe: !this.state.toggleMotefareghe });
	}
	flatTreeData(data) {
		var flatData = [];
		for (var i = 0; i < data.length; i++) {
			for (var j = 0; j < data[i].children.length; j++) {
				var results = this.flatTreeDataLoop(data[i].children[j]);
				for (var x = 0; x < results.length; x++) {
					flatData.push(results[x]);
				}
			}
		}
		return flatData;
	}
	validateOrderType() {
		return this.state.orderType !== false;
	}

	flatTreeDataLoop(tree) {
		if (parseInt(tree.leaf) === 1) {
			var data = [];
			for (var i = 0; i < tree.children.length; i++) {
				data.push(tree.children[i]);
			}
			return data;
		} else {
			var data = [];
			for (var i = 0; i < tree.children.length; i++) {
				var results = this.flatTreeDataLoop(tree.children[i]);
				for (var x = 0; x < results.length; x++) {
					data.push(results[x]);
				}
			}
			return data;
		}
	}
	validatePlaceOrder() {
		return this.state.customerMobile.isValid && this.validateOrderType() && this.validateRating() && this.getTotalPayAblePrice() > 0;
	}
	changeCountFromFactor(id, count) {
		var tmpObj = this.state.productsData;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].id == id) {
				if (tmpObj[i].count == 0 && count > 0) {
					tmpObj[i].sort = Date.now();
				}
				if (count == 0) {
					tmpObj[i].sort = undefined;
				}
				tmpObj[i].count = count;
			}
		}

		this.setState({ productsData: tmpObj });

		var tmpObj = this.state.variableProducts;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].id == id) {
				tmpObj[i].count = count;
			}
		}
		this.setState({ variableProducts: tmpObj });
	}
	deleteFromFactor(id) {
		var tmpObj = this.state.productsData;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].id == id) {
				tmpObj[i].sort = undefined;
				tmpObj[i].count = 0;
			}
		}

		this.setState({ productsData: tmpObj });

		var tmpObj = this.state.variableProducts;
		for (var i = 0; i < tmpObj.length; i++) {
			if (tmpObj[i].id == id) {
				tmpObj.splice(i, 1);
			}
		}
		this.setState({ variableProducts: tmpObj });
	}
	validateAddVariableProduct() {
		var $enabled = true;

		if (this.state.variableProduct.name.trim() == "" || this.state.variableProduct.name.length < 3) {
			$enabled = false;
		}
		if (this.state.variableProduct.count < 1) {
			$enabled = false;
		}

		return !$enabled;
	}

	addVariableProduct() {
		this.state.variableProducts.push({
			id: "V-" + this.state.variableProduct.idCounter,
			idCounter: this.state.variableProduct.idCounter,
			name: this.state.variableProduct.name,
			price: parseInt(this.state.variableProduct.price),
			count: parseInt(this.state.variableProduct.count),
			type: "VARIABLE",
		});
		this.setState({
			variableProduct: {
				id: "V-" + this.state.variableProduct.idCounter + 1,
				idCounter: this.state.variableProduct.idCounter + 1,
				name: "",
				price: 0,
				count: 0,
				type: "VARIABLE",
			},
		});
	}
	toggleDisplayOptions() {
		this.setState({ displayOptionsIsOpen: !this.state.displayOptionsIsOpen });
	}
	toggleSplit() {
		this.setState((prevState) => ({
			dropdownSplitOpen: !prevState.dropdownSplitOpen,
		}));
	}

	toggleAccordion(tab) {
		const prevState = this.state.accordion;
		const state = prevState.map((x, index) => (tab === index ? !x : false));
		this.setState({
			accordion: state,
		});
	}

	productPanelInfo = (categoryName) => {
		return (
			<div className="text-left accardion-item-sum ">
				<NumberFormat value={this.getCategoryCount(categoryName)} displayType={"text"} suffix={" عدد"} thousandSeparator={true} renderText={(value, price) => <span className="dataItemCount">{value}</span>} />
				<span className="dataDivider"> | </span>
				<NumberFormat value={this.getCategoryTotal(categoryName)} displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <span className="dataPriceTotal">{value}</span>} />
			</div>
		);
	};
	getItemCount(id) {
		const data = this.state.productsData;

		for (var i = 0; i < data.length; i++) {
			if (data[i].id == id) {
				return data[i].count;
			}
		}
	}
	getItemPrice(id) {
		const data = this.state.productsData;

		for (var i = 0; i < data.length; i++) {
			if (data[i].id == id) {
				return data[i].price;
			}
		}
	}
	getItemStockData = id => this.state.productsData.find(product => String(product.id) === String(id));
	getItemStock(id) {
		const data = this.state.productsData;

		for (var i = 0; i < data.length; i++) {
			if (data[i].id == id) {
				return data[i].stockLevel >= 0 ? data[i].stockLevel : 0;
			}
		}
	}
	getItemReserved(id) {
		const data = this.state.productsData;

		for (var i = 0; i < data.length; i++) {
			if (data[i].id == id) {
				return data[i].stockReserved;
			}
		}
	}
	handleCountUpdate(id, count) {
		const data = this.state.productsData;

		const newData = data.map((row) => {
			if (row.id === id) {
				if (row.count == 0 && count > 0) {
					row.sort = Date.now();
				}
				if (count == 0) {
					row.sort = undefined;
				}
				return {
					...row,
					count,
				};
			}
			return row;
		});

		var newProductsData = this.state.productsData;
		newProductsData = newData;
		this.setState({ productsData: newProductsData });
	}
	getCountedProducts = () => {
		const data = this.state.productsData;
		var newData = data.filter((row) => {
			if (row.count > 0) {
				return {
					...row,
				};
			}
		});
		newData = newData.sort((a, b) => {
			if (a.sort < b.sort) {
				return -1;
			}
			if (a.sort > b.sort) {
				return 1;
			}
			return 0;
		});
		newData = newData.concat(this.state.variableProducts);
		return newData;
	};
	compare(a, b) {}

	getCategoryProducts = (categoryName) => {
		const data = this.state.productsData;
		const newData = data.filter((row) => {
			if (row.category === categoryName) {
				return {
					...row,
				};
			}
		});

		return newData;
	};
	getCategoryTotal = (categoryName) => {
		var total = 0;
		for (var i = 0; i < this.state.productsData.length; i++) {
			if (this.state.productsData[i].category == categoryName) {
				total += this.state.productsData[i].count * this.state.productsData[i].price;
			}
		}
		return total;
	};
	getCategoryCount = (categoryName) => {
		var total = 0;
		for (var i = 0; i < this.state.productsData.length; i++) {
			if (this.state.productsData[i].category == categoryName) {
				total += this.state.productsData[i].count;
			}
		}
		return total;
	};
	getFactorTotalCounts = () => {
		var total = 0;
		for (var i = 0; i < this.state.productsData.length; i++) {
			total += this.state.productsData[i].count;
		}
		for (var i = 0; i < this.state.variableProducts.length; i++) {
			total += this.state.variableProducts[i].count;
		}
		return total;
	};
	getFactorTotalPrice = () => {
		var total = 0;
		for (var i = 0; i < this.state.productsData.length; i++) {
			total += this.state.productsData[i].count * this.state.productsData[i].price;
		}
		for (var i = 0; i < this.state.variableProducts.length; i++) {
			total += this.state.variableProducts[i].count * this.state.variableProducts[i].price;
		}
		return total;
	};

	handleChange = (selectedOption) => {
		this.setState({ selectedOption });
	};

	handleChangeType = (selectedOptionsType) => {
		this.setState({ selectedOptionsType });
	};

	handlediscountPercent = (e) => {
		if ((e == 0 || e == "") && (this.state.discountPercent != 0 || discountType != "FIXED")) {
			this.setState({ discountPercent: 0, discountType: "FIXED", discountAmount: 0 });
		} else {
			if (this.getFactorTotalPrice() > 0) {
				this.setState({
					discountPercent: e,
					discountAmount: (this.getFactorTotalPrice() * e) / 100,
					discountType: "PERCENT",
				});
			} else {
				this.setState({ discountPercent: 0, discountType: "FIXED", discountAmount: 0 });
			}
		}
	};
	getTotalPayAblePrice() {
		return this.getFactorTotalPrice() - this.totalDiscount().amount + this.state.additionalFee;
	}
	render() {
		const startIndex = (this.state.currentPage - 1) * this.state.selectedPageSize;
		const endIndex = this.state.currentPage * this.state.selectedPageSize;
		const { messages } = this.props.intl;
		return this.state.isLoading ? (
			<div className="loading"></div>
		) : (
			<Fragment>
				{/* <Row>
          <Colxx xxs="12">
            <BreadcrumbContainer
              heading={<IntlMessages id="menu.new-order" />}
              match={this.props.match}
            />
            <Separator className="mb-5" />
          </Colxx>
        </Row> */}
				<Row className="mb-4">
					<Colxx xxs="12">
						<Form>
							<FormGroup row>
								<Colxx sm={6}>
									<Card className="timeline-card " style={{ backgroundColor: "transparent" }}>
										<CardBody style={{ backgroundColor: "rgba(0,0,0,0.03)" }}>
											<div className="">
												<Fragment>
													{this.state.productsDataTree.map((item) => (
														<AccardionRender
															key={item.id}
															data={item}
															onCountUpdate={this.handleCountUpdate}
															getItemCount={this.getItemCount}
															getItemPrice={this.getItemPrice}
															getItemStock={this.getItemStock}
															getItemReserved={this.getItemReserved}
															getItemStockData={this.getItemStockData}
														/>
													))}

													<hr />

													<div key={2000} className="neworder border productPanel">
														<Button block color="link" className="text-right" onClick={() => this.toggleMotefareghe()} aria-expanded={this.state.toggleMotefareghe}>
															متفرقه
														</Button>

														<Collapse isOpen={this.state.toggleMotefareghe}>
															<div className="p-4">
																<div className="table-responsive">
																	<table className="table">
																		<tbody style={{ background: "#ffffff" }}>
																			<tr>
																				<td>نام محصول</td>
																				<td colSpan="2">
																					<input
																						name="vproductname"
																						value={this.state.variableProduct.name}
																						onChange={(e) => {
																							var tmpObj = { ...this.state.variableProduct };
																							tmpObj.name = e.target.value;
																							this.setState({ variableProduct: tmpObj });
																						}}
																						style={{ width: "100%" }}
																					/>
																				</td>
																			</tr>
																			<tr>
																				<td>قیمت واحد </td>
																				<td>
																					<NumberFormat
																						value={this.state.variableProduct.price}
																						onValueChange={(values) => {
																							var tmpObj = { ...this.state.variableProduct };
																							tmpObj.price = values.value;
																							this.setState({ variableProduct: tmpObj });
																						}}
																						thousandSeparator={true}
																						onClick={this.handleFocus}
																					/>
																				</td>
																				<td>تومان</td>
																			</tr>
																			<tr>
																				<td> تعداد </td>
																				<td>
																					<NumericInput
																						value={this.state.variableProduct.count}
																						onChange={(e) => {
																							var tmpObj = { ...this.state.variableProduct };
																							tmpObj.count = e;
																							this.setState({ variableProduct: tmpObj });
																						}}
																						size={3}
																						min={0}
																					/>
																				</td>
																				<td>عدد</td>
																			</tr>
																			<tr>
																				<td> جمع قیمت </td>
																				<td>
																					<NumberFormat
																						value={this.state.variableProduct.count * this.state.variableProduct.price}
																						displayType={"text"}
																						thousandSeparator={true}
																						renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																					/>
																				</td>
																				<td>تومان</td>
																			</tr>
																			<tr>
																				<td colSpan="2"></td>
																				<td>
																					<Button color="primary" className="default mb-2" disabled={this.validateAddVariableProduct()} onClick={this.addVariableProduct}>
																						اضافه کن
																					</Button>
																				</td>
																			</tr>
																		</tbody>
																	</table>
																</div>
															</div>
														</Collapse>
													</div>
												</Fragment>
											</div>
										</CardBody>
									</Card>
								</Colxx>

								<Colxx sm={6}>
									<Card id={"side-card"}>
										<CardBody>
											<CardTitle>
												<div className={"iconsminds-add-file headingicon"} />
												فرم ثبت سفارش
											</CardTitle>
											<Row className="mb-4">
												<Colxx sm={6}>
													{/* <FormGroup className={"filter " + (this.validateMobile(this.state.customerMobile) ? "filter-active" : "")}>
														‌
														{this.state.searchCustomer.ID != "" ? (
															<a
																href={"/app/customers/view-customer/" + this.state.customerMobile}
																target="_blank"
																className={classNames({
																	"iconsminds-business-man": this.state.searchCustomer.Gender == "MALE" ? true : false,
																	"iconsminds-business-woman": this.state.searchCustomer.Gender == "FEMALE" ? true : false,
																	headingicon: true,
																})}
															>
																{this.state.searchCustomer.Name} {this.state.searchCustomer.SurName} #{this.state.searchCustomer.ID}
															</a>
														) : this.state.searchCustomer.isLead ? (
															<a href={"/app/crm/lead/view/" + this.state.customerMobile} target="_blank" className="iconsminds-pulse headingicon">
																سرنخ با{" "}
																<span className="pulsecount" style={{ fontWeight: "bold" }}>
																	{this.state.searchCustomer.PulseCount}
																</span>{" "}
																پالس
															</a>
														) : (
															<Label for="customerMobile">{this.validateMobile(this.state.customerMobile) ? <span> مشتری جدید*</span> : <span> موبایل مشتری</span>}</Label>
														)}
														<Input
															autoComplete="off"
															type="text"
															name="customerMobile"
															id="customermobile"
															placeholder=""
															value={this.state.customerMobile}
															onChange={(e) => {
																var cleanValue = this.cleanCustomerMobile(e.target.value);
																this.setState({ customerMobile: cleanValue });
																this.lookupCustomer(cleanValue);
															}}
														/>
													</FormGroup> */}
													<CustomerMobileLookup
														isValid={this.state.customerMobile.isValid}
														ref={this.customerMobileLookupComponent}
														customerMobileObject={this.state.customerMobile}
														onCustomerMobileChange={this.handleCustomerMobileChange}
													/>
												</Colxx>

												<Colxx sm={6}>
													<FormGroup className={"filter " + (this.validateOrderType() ? "filter-active" : "")}>
														<Label for="exCustomRadio">نوع سفارش</Label>
														<div>
															<CustomInput
																type="radio"
																id="exCustomRadio"
																name="customRadio"
																label="چت"
																onChange={(e) => {
																	this.setState({ orderType: "CHAT" });
																}}
															/>
															<CustomInput
																type="radio"
																id="exCustomRadio2"
																name="customRadio"
																label="حضوری"
																onChange={(e) => {
																	this.setState({ orderType: "SHOP" });
																}}
															/>
															<CustomInput
																type="radio"
																name="customRadio"
																id="exCustomRadio3"
																label="سایت"
																onChange={(e) => {
																	this.setState({ orderType: "SITE" });
																}}
															/>
														</div>
													</FormGroup>
													<FormGroup></FormGroup>
												</Colxx>
											</Row>
											<Row className="mb-4">
												<Colxx sm={12}>
													<table className="table">
														<thead>
															<tr>
																<th style={{ textAlign: "center", maxWidth: "20px" }}>
																	<div className={"glyph-icon simple-icon-trash"} />
																</th>
																{/* <th style={{ textAlign: "center", maxWidth: "20px" }}>
																	<div className={"glyph-icon simple-icon-list"} />
																</th> */}
																<th style={{ textAlign: "center", maxWidth: "20px" }}>
																	<div className={"glyph-icon iconsminds-box-close"} style={{ padding: "0", margin: "0", marginBottom: "-7px", transform: "scale(1.2)" }} />
																</th>
																<th>نام محصول</th>
																<th style={{ textAlign: "center" }}>قیمت واحد</th>
																<th style={{ textAlign: "center" }}>تعداد </th>
																<th style={{ textAlign: "center", minWidth: "120px" }}>قیمت کل</th>
															</tr>
														</thead>
														<tbody>
															{this.getCountedProducts().map((row, index) => (
																<FactorTableRow index={index} key={row.id} data={row} doDelete={this.deleteFromFactor} doChangeCount={this.changeCountFromFactor} />
															))}
															<tr style={{ backgroundColor: "#ffa5002e" }}>
																<td style={{ textAlign: "center", width: "20px" }} colSpan={1}>
																	{" "}
																	<div style={{ fontSize: "20px" }} className={"glyph-icon simple-icon-plus"} />
																</td>
																<td>{/* {this.getCountedProducts().length + 1} */}</td>
																<td colSpan={4}>
																	<ReactAutosuggest
																		className="stock-indicator-search"
																		placeholder={"بخشی از نام محصول مورد نظر"}
																		data={this.state.productsDataWithStock}
																		renderSuggestion={suggestion => (
																			<StockSuggestion suggestion={suggestion} />
																		)}
																		onSelect={(value) => {
																			this.getItemCount(value) > 0 ? NotificationManager.error("این محصول قبلا در فاکتو وجود داشت", "", 3000, null, null, "filled") : this.changeCountFromFactor(value, 1);
																		}}
																	/>
																</td>
															</tr>
														</tbody>
														<tfoot>
															<tr>
																<td colSpan="6"></td>
															</tr>
															<tr className="order-new-table-totalrow" style={{ borderTop: "3px solid lightgray" }}>
																<td colSpan="2" style={{ maxWidth: "40px" }}>
																	<div style={{ fontSize: "24px", color: "gray" }} className={"glyph-icon iconsminds-cash-register-2"} />
																</td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ color: "gray" }}>
																	جمع کل
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: "gray" }}>
																	-
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: "gray" }}>
																	<NumberFormat
																		value={this.getFactorTotalCounts()}
																		displayType={"text"}
																		suffix={" عدد"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: "gray" }}>
																	<NumberFormat
																		value={this.getFactorTotalPrice()}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
															</tr>
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<Switch
																		className="custom-switch custom-switch-primary"
																		checked={this.state.useCoupon}
																		onChange={(useCoupon) => {
																			this.setState({ useCoupon, discountPercent: 0, discountAmount: 0, coupon: {}, couponID: -1 });
																		}}
																		style={{
																			display: "inline-block",
																			marginLeft: "12px",
																			float: "right",
																		}}
																	/>
																</td>

																<td colSpan="1" className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.useCoupon ? "black" : "lightgray", verticalAlign: "middle" }}>
																	کوپن تخفیف
																</td>

																<td colSpan="3" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	{this.state.couponID === -1 ? (
																		<div>
																			<Button
																				className={"default mb-1"}
																				outline
																				disabled={!this.state.useCoupon || this.state.couponCode.length < 5 || this.state.lookingUpCoupon}
																				color={!this.state.useCoupon || this.state.couponCode.length < 5 ? "black" : "info"}
																				style={{ float: "left", display: "inline", border: "unset", width: "40px", marginRight: "5px", borderRadius: 5, padding: "11px" }}
																				onClick={() => {
																					this.couponLookup();
																				}}
																			>
																				<div className={"simple-icon-check tableheadingicon"} />
																			</Button>
																			<Input
																				autoComplete="off"
																				type="text"
																				name="couponCode"
																				id="couponCode"
																				placeholder="COUPON-CODE"
																				style={{ textAlign: "left", display: "inline-block", width: "auto", float: "left" }}
																				disabled={!this.state.useCoupon || this.state.lookingUpCoupon}
																				value={this.state.couponCode}
																				onChange={(e) => {
																					this.setState({ couponCode: e.target.value });
																				}}
																			/>
																		</div>
																	) : (
																		<div>
																			<a href={"/app/crm/coupon/view/" + this.state.couponID} target="_blank">
																				{" "}
																				<div className={classNames({ coupon: true, "coupon-disabled": !this.state.useCoupon })} style={{ color: "#556270" }}>
																					<span>{this.state.couponCode}</span>
																				</div>{" "}
																			</a>
																			<Button
																				style={{
																					position: "absolute",
																					padding: "5px",
																					color: "black",
																					backgroundColor: "transparent",
																					border: "unset",
																				}}
																				onClick={(e) => {
																					this.setState({ couponID: -1, couponCode: "" });
																				}}
																			>
																				<i className="simple-icon-close"></i>
																			</Button>
																		</div>
																	)}
																</td>
															</tr>
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<div style={{ fontSize: "24px", color: this.state.discountAmount > 0 && !this.state.useCoupon ? "black" : "lightgray" }} className={"glyph-icon iconsminds-dollar"} />
																</td>

																<td
																	colSpan="2"
																	className="order-new-table-width55 font-weight-semibold "
																	style={{ color: this.state.discountAmount > 0 && !this.state.useCoupon ? "black" : "lightgray", verticalAlign: "middle" }}
																>
																	تخفیف
																</td>

																<td className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle" }}>
																	<NumericInput disabled={this.state.useCoupon} value={this.state.discountPercent} onChange={this.handlediscountPercent} size={2} min={0} max={100} /> %
																</td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.discountAmount > 0 ? "black" : "lightgray", textAlign: "left", verticalAlign: "middle" }}>
																	<NumberFormat
																		value={this.state.discountAmount}
																		onClick={this.handleFocus}
																		onValueChange={(values) => {
																			this.setState({ discountAmount: values.value });
																		}}
																		disabled={this.state.discountType == "PERCENT" || this.state.useCoupon}
																		style={{ width: "60px", textAlign: "left" }}
																		thousandSeparator={true}
																	/>{" "}
																	تومان
																</td>
															</tr>
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<div style={{ fontSize: "24px", color: this.totalDiscount().amount > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-dollar"} />
																</td>

																<td colSpan="1" className="order-new-table-width55 font-weight-semibold " style={{ color: this.totalDiscount().amount > 0 ? "black" : "lightgray", verticalAlign: "middle" }}>
																	تخفیف کل
																</td>

																<td colSpan="2" className="order-new-table-width15 font-weight-semibold " style={{ verticalAlign: "middle", color: this.totalDiscount().infoColor == "error" ? "red" : "green" }}>
																	{this.totalDiscount().info}
																</td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.totalDiscount().amount > 0 ? "black" : "lightgray", textAlign: "left", verticalAlign: "middle" }}>
																	<NumberFormat
																		value={this.totalDiscount().amount}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataPriceTotal">{value}</span>}
																	/>
																</td>
															</tr>
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<div style={{ fontSize: "24px", color: this.state.additionalFee > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-scooter"} />
																</td>
																<td colSpan="2" className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.additionalFee > 0 ? "black" : "lightgray", verticalAlign: "middle" }}>
																	هزینه حمل و جانبی
																</td>
																<td></td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.state.additionalFee > 0 ? "black" : "lightgray", textAlign: "left", verticalAlign: "middle" }}>
																	<NumberFormat
																		value={this.state.additionalFee}
																		onClick={this.handleFocus}
																		onValueChange={(values) => {
																			this.setState({ additionalFee: parseInt(values.value) });
																		}}
																		style={{ width: "60px", textAlign: "left" }}
																		thousandSeparator={true}
																	/>{" "}
																	تومان
																</td>
															</tr>
															<tr className="order-new-table-totalrow">
																<td style={{ width: "40px", verticalAlign: "middle" }} colSpan="2">
																	<div style={{ fontSize: "24px", color: this.getFactorTotalCounts() > 0 ? "black" : "lightgray" }} className={"glyph-icon iconsminds-coins"} />
																</td>
																<td className="order-new-table-width55 font-weight-semibold " style={{ color: this.getFactorTotalCounts() > 0 ? "black" : "lightgray", verticalAlign: "middle" }}>
																	قابل پرداخت
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: this.getFactorTotalCounts() > 0 ? "black" : "lightgray", verticalAlign: "middle" }}>
																	-
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: this.getFactorTotalCounts() > 0 ? "black" : "lightgray", verticalAlign: "middle", textAlign: "left" }}>
																	<NumberFormat
																		value={this.getFactorTotalCounts()}
																		displayType={"text"}
																		suffix={" عدد"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
																<td className="order-new-table-width15 font-weight-semibold " style={{ color: this.getFactorTotalCounts() > 0 ? "black" : "lightgray", verticalAlign: "middle", textAlign: "left" }}>
																	<NumberFormat
																		value={this.getTotalPayAblePrice()}
																		displayType={"text"}
																		suffix={" تومان"}
																		thousandSeparator={true}
																		renderText={(value, price) => <span className="dataItemCount">{value}</span>}
																	/>
																</td>
															</tr>
															<tr>
																<td colSpan="6"></td>
															</tr>
															<tr>
																<td colSpan="2">
																	<div
																		onClick={(e) => {
																			var tmpObj = { ...this.state.factorItems };
																			tmpObj.notePublic = !tmpObj.notePublic;
																			this.setState({ factorItems: tmpObj });
																		}}
																		style={{ cursor: "pointer", fontSize: "24px", color: this.state.factorItems.notePublic ? "black" : "lightgray" }}
																		className={"glyph-icon simple-icon-flag"}
																	/>
																</td>
																<td colSpan="4" style={{ verticalAlign: "middle" }}>
																	<label style={{ color: this.state.factorItems.notePublic ? "black" : "lightgray" }}>توضیح عمومی برای درج در فاکتور:</label>
																	<textarea
																		rows="4"
																		style={{ width: "100%", display: this.state.factorItems.notePublic ? "block" : "none" }}
																		onChange={(e) => {
																			this.setState({ notePublic: e.target.value });
																		}}
																	/>
																</td>
															</tr>
															<tr>
																<td colSpan="2">
																	<div
																		onClick={(e) => {
																			var tmpObj = { ...this.state.factorItems };
																			tmpObj.notePirvate = !tmpObj.notePirvate;
																			this.setState({ factorItems: tmpObj });
																		}}
																		style={{ cursor: "pointer", fontSize: "24px", color: this.state.factorItems.notePirvate ? "black" : "lightgray" }}
																		className={"glyph-icon simple-icon-ghost"}
																	/>
																</td>
																<td colSpan="4" style={{ verticalAlign: "middle" }}>
																	<label style={{ color: this.state.factorItems.notePirvate ? "black" : "lightgray" }}>توضیح مخفی برای سیستم:</label>
																	<textarea
																		style={{ width: "100%", display: this.state.factorItems.notePirvate ? "block" : "none" }}
																		rows="4"
																		onChange={(e) => {
																			this.setState({ notePrivate: e.target.value });
																		}}
																	/>
																</td>
															</tr>
															<tr>
																<td colSpan="2" style={{ verticalAlign: "middle" }}>
																	<div style={{ cursor: "pointer", fontSize: "24px", color: this.state.DeliveryInPerson ? "black" : "lightgray" }} className={"glyph-icon iconsminds-shop-2"} />
																</td>
																<td colSpan="4" style={{ verticalAlign: "middle" }}>
																	<label style={{ color: this.state.DeliveryInPerson ? "black" : "lightgray" }}>مشتری سفارش را حضوری تحویل میگیرد:</label>
																	<Switch
																		className="custom-switch custom-switch-primary"
																		checked={this.state.DeliveryInPerson}
																		onChange={(DeliveryInPerson) => {
																			this.setState({ DeliveryInPerson });
																		}}
																		style={{
																			display: "inline-block",
																			marginLeft: "12px",
																			float: "left",
																		}}
																	/>
																	&nbsp;&nbsp;
																	{this.state.DeliveryInPerson ? "دریافت حضوری" : ""}
																</td>
															</tr>
															{/* <tr>
																<td colSpan="2" style={{ verticalAlign: "middle" }}>
																	<div style={{ cursor: "pointer", fontSize: "24px", color: this.state.factorItems.rating ? "black" : "lightgray" }} className={"glyph-icon simple-icon-star"} />
																</td>
																<td colSpan="4" style={{ verticalAlign: "middle" }}>
																	<label style={{ color: this.state.factorItems.rating ? "black" : "lightgray" }}>امتیاز اپراتور به مشتری برای این سفارش:</label>
																	<Rating
																		total={5}
																		rating={this.state.ratingOperator}
																		color={"danger"}
																		onRate={(rating) => {
																			this.setState({ ratingOperator: rating.rating });
																		}}
																		style={{ float: "left" }}
																	/>
																</td>
															</tr> */}
															<tr>
																<td colSpan="5"></td>
																<td colSpan="1" style={{ verticalAlign: "middle" }}>
																	<Button
																		color="primary"
																		className="default mb-2 btn-shadow"
																		onClick={() => {
																			this.placeOrder();
																		}}
																		disabled={!this.validatePlaceOrder()}
																	>
																		ثبت سفارش
																	</Button>
																	<Modal isOpen={this.state.modalURL}>
																		<ModalHeader>سفارش به شماره {"#" + this.state.orderID} ثبت شد.</ModalHeader>
																		<ModalBody>
																			<label>آدرس فرم تکمیل اطلاعات سفارش:</label>
																			<br />
																			<input
																				disabled
																				value={this.state.orderUrl}
																				style={{ marginLeft: "5px", lineHeight: "30px", width: "330px", textAlign: "left", padding: "7px", fontSize: "16px", fontFamily: "Courier" }}
																			/>
																			<Button
																				color="primary"
																				className="default mb-2"
																				style={{ padding: "10px" }}
																				onClick={() => {
																					navigator.clipboard.writeText(this.state.orderUrl);
																					NotificationManager.primary(this.state.orderUrl, "آدرس یکتای سفارش کپی شد.", 3000, null, null, "filled");
																				}}
																			>
																				<div style={{ fontSize: "14px", display: "inline-block" }} className={"glyph-icon simple-icon-link"} /> کپی آدرس
																			</Button>
																		</ModalBody>
																		<ModalFooter>
																			<Button
																				color="light"
																				className="default mb-2"
																				onClick={() => {
																					confirm("آیا آدرس را کپی و برای کاربر ارسال نمودید؟") ? this.setState({ modalURL: false }, window.location.reload()) : false;
																				}}
																			>
																				بستن
																			</Button>{" "}
																		</ModalFooter>
																	</Modal>
																</td>
															</tr>
														</tfoot>
													</table>
												</Colxx>
											</Row>
										</CardBody>
									</Card>
								</Colxx>
							</FormGroup>
						</Form>
					</Colxx>
				</Row>
			</Fragment>
		);
	}
}
class AccardionRender extends Component {
	constructor(props) {
		super(props);

		this.state = {
			toggle: false,
		};
		this.toggle = this.toggle.bind(this);
	}
	toggle() {
		this.setState({ toggle: !this.state.toggle });
	}
	render() {
		const {
			data: { name, type, id, children, leaf },
		} = this.props;

		return (
			<Fragment>
				<div key={id} className="neworder border productPanel">
					<Button block color="link" className="text-right" onClick={() => this.toggle()} aria-expanded={this.state.toggle}>
						{name}

						{/* {this.productPanelInfo(categoryName)} */}
					</Button>

					<Collapse isOpen={this.state.toggle}>
						{type == "category" && parseInt(leaf) === 0 ? (
							<div className="p-4">
								{/* {console.log(children)} */}
								{children !== undefined &&
									children.map((child) => (
										<AccardionRender
											key={child.id}
											data={child}
											onCountUpdate={this.props.onCountUpdate}
											getItemCount={this.props.getItemCount}
											getItemPrice={this.props.getItemPrice}
											getItemStock={this.props.getItemStock}
											getItemReserved={this.props.getItemReserved}
											getItemStockData={this.props.getItemStockData}
										/>
									))}
							</div>
						) : (
							<div className="p-4">
								<div className="table-responsive">
									<table className="table table-hover stock-indicator-tree-table">
										<colgroup><col /><col style={{ width: '88px' }} /><col style={{ width: '56px' }} /><col style={{ width: '128px' }} /><col style={{ width: '92px' }} /></colgroup>
										<thead>
											<tr>
												<th>نام محصول</th>
												<th className="stock-indicator-tree-stock">موجودی</th>
												<th className="stock-indicator-tree-reserved">رزرو</th>
												<th className="stock-indicator-tree-price">قیمت </th>
												<th className="stock-indicator-tree-count">تعداد</th>
											</tr>
										</thead>
										<tbody>
											{children !== undefined &&
												children.map((child) => (
													<TableRow
														key={child.id}
														data={child}
														onCountUpdate={this.props.onCountUpdate}
														getItemCount={this.props.getItemCount}
														getItemPrice={this.props.getItemPrice}
														getItemStock={this.props.getItemStock}
														getItemReserved={this.props.getItemReserved}
											getItemStockData={this.props.getItemStockData}
													/>
												))}
										</tbody>
									</table>
								</div>
							</div>
						)}
					</Collapse>
				</div>
			</Fragment>
		);
	}
}
class TableRow extends Component {
	handleChange = (e) => {
		this.props.onCountUpdate(this.props.data.id, e);
	};

	render() {
		const {
			data: { id, name, stock, price },
		} = this.props;

		var color = this.props.getItemCount(id) > 0 ? "#f3f3f3" : "";
		return (
			<tr style={{ backgroundColor: color }}>
				<td>{name}</td>
				<td className="stock-indicator-cell stock-indicator-tree-stock">
					<StockBox product={this.props.getItemStockData(id)}>
						<NumberFormat style={{ textAlign: "center" }} value={this.props.getItemStock(id)} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, price) => <span>{value}</span>} />
					</StockBox>
				</td>
				<td className="stock-indicator-tree-reserved">
					<NumberFormat style={{ textAlign: "center" }} value={this.props.getItemReserved(id)} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, price) => <div>{value}</div>} />
				</td>
				<td className="stock-indicator-tree-price">
					<NumberFormat style={{ textAlign: "center" }} value={this.props.getItemPrice(id)} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, price) => <div>{value}</div>} />
				</td>
				<td className="stock-indicator-tree-count">
					<NumericInput mobile value={this.props.getItemCount(id)} onChange={this.handleChange} size={3} min={0} />
				</td>
			</tr>
		);
	}
}

class FactorTableRow extends Component {
	handleChange = (e) => {
		this.props.onCountUpdate(this.props.data.id, e);
	};

	handleDelete = () => {
		this.props.doDelete(this.props.data.id);
	};
	handleChangeCount = (e) => {
		this.props.doChangeCount(this.props.data.id, e);
	};
	render() {
		const {
			data: { id, name, stock, price, count, stockLevel, stockReserved },
			index,
		} = this.props;
		var color = index % 2 == 0 ? "#00ffed0d" : "#ffffff";
		return (
			<tr style={{ backgroundColor: color }}>
				<td style={{ textAlign: "center", width: "20px" }}>
					<Button outline color="primary" className="mb-2" onClick={this.handleDelete} style={{ padding: "5px" }}>
						<div className={"glyph-icon simple-icon-trash"} />
					</Button>
				</td>
				{/* <td style={{ textAlign: "center", width: "20px" }}>{index + 1}</td> */}
				<td className="stock-indicator-cell" style={{ textAlign: "center", width: "20px" }}>
					<StockBox product={this.props.data}>
						<span>{stockLevel >= 0 ? stockLevel : 0}{stockReserved > 0 && ` : ~${stockReserved}`}</span>
					</StockBox>
				</td>{" "}
				<td>{name}</td>
				<td style={{ textAlign: "center", width: "80px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={price} className="text-muted" displayType={"text"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
				<td style={{ textAlign: "center", width: "20px" }}>
					<span className="stock-indicator-quantity">
						<StockIndicator product={this.props.data} quantity={count} />
						<NumericInput mobile value={count} onChange={this.handleChangeCount} size={3} min={0} />
					</span>
				</td>
				<td style={{ textAlign: "center", width: "250px" }}>
					<NumberFormat style={{ textAlign: "center" }} value={price * count} className="text-muted" displayType={"text"} suffix={" تومان"} thousandSeparator={true} renderText={(value, prop) => <div>{value}</div>} />
				</td>
			</tr>
		);
	}
}

const mapStateToProps = ({ menu, settings }) => {
	return { logoutUser };
};
export default injectIntl(connect(mapStateToProps, { logoutUser })(NewOrder));
// export default injectIntl(NewOrder);
